// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  single: null,
  info: [],
  error: null,
};
const CategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_CATEGORYWEB":
      return {
        ...state,
        allData: action.data,
        data: action.data,
        total: action.totalPages,
        params: action.params,
        info: action.info,
      };
    case "EMPTY_ERROR":
    case "ADD_CATEGORYWEB_SUCCESS":
    case "ADD_CATEGORYBLOG_SUCCESS":
    case "EDIT_SECTION_SUCCESS":
      return { ...state, error: null };
    case "ADD_CATEGORYWEB_FAIL":
    case "ADD_CATEGORYBLOG_FAIL":

    case "EDIT_SECTION_FAIL":
      return { ...state, error: action.payload };
    default:
      return { ...state };
  }
};

export default CategoryReducer;
